<template>
  <div class="my-licence">
    <div class="account-card">
      <div class="account-card-header" style="margin-bottom:20px">
        <h4 class="account-card-title">资格审核</h4>
      </div>
      <div class="form">
        <el-form :model="ruleForm" ref="ruleForm" label-width="160px">
          <el-row>
            <el-col :span="12">
              <el-form-item label="公告编号:">
                <span>{{ ruleForm.code }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="公告标题:">
                <span>{{ ruleForm.title }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="竞价开始时间:">
                <span>{{ ruleForm.bidStartTime }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="报名截止时间:">
                <span>{{ ruleForm.enrollEndTime }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item
            v-if="ruleForm.dismantleWhether == 1"
            label="是否允许联合体受让:"
            ><span>{{ ruleForm.jointWhether == 1 ? '是' : '否' }}</span>
          </el-form-item>
        </el-form>
      </div>
      <div class="titlepen">
        <div style="display: flex;justify-content: space-between;">
          <span style="line-height: 60px">已选择{{ number }}个竞买人</span>
          <div>
            <el-button type="primary" @click="onSubmit">提交</el-button>
            <el-button type="primary" @click="operation">批量审核</el-button>
            <el-button type="primary" @click="exportNoAudit">导出</el-button>
            <el-button type="primary" @click="onLead">导入</el-button>
          </div>
        </div>

        <el-table
          border
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%;"
          @selection-change="handleSelectionChange"
        >
          <el-table-column
            type="selection"
            width="55"
            :selectable="selectable"
            align="center"
          >
          </el-table-column>
          <el-table-column label="序号" type="index" width="50" align="center">
            <template slot-scope="scope">
              <span
                :class="
                  scope.row.jointCompNameNum && scope.row.jointCompNameNum > 1
                    ? 'redcolumn'
                    : ''
                "
                >{{ scope.$index + 1 }}</span
              >
            </template>
          </el-table-column>
          <el-table-column
            label="竞买人"
            width="120"
            show-overflow-tooltip
            align="center"
          >
            <template slot-scope="scope">
              <span class="cell-link" @click="oncompName(scope.row)">
                {{ scope.row.compName }}</span
              ></template
            >
          </el-table-column>
          <el-table-column
            prop="registerAmount"
            label="注册资金"
            width="120"
            align="center"
          >
            <template slot-scope="scope">
              <span
                :class="
                  scope.row.jointCompNameNum && scope.row.jointCompNameNum > 1
                    ? 'redcolumn'
                    : ''
                "
              >
                {{ scope.row.registerAmount }}</span
              ></template
            >
          </el-table-column>
          <el-table-column
            prop="straddrEc"
            label="所在地"
            show-overflow-tooltip
            align="center"
          >
            <template slot-scope="scope">
              <span
                :class="
                  scope.row.jointCompNameNum && scope.row.jointCompNameNum > 1
                    ? 'redcolumn'
                    : ''
                "
              >
                {{ scope.row.straddrEc }}</span
              ></template
            >
          </el-table-column>
          <el-table-column
            prop="submitTime"
            label="报名时间"
            width="150"
            align="center"
          >
            <template slot-scope="scope">
              <span
                :class="
                  scope.row.jointCompNameNum && scope.row.jointCompNameNum > 1
                    ? 'redcolumn'
                    : ''
                "
              >
                {{ scope.row.submitTime }}</span
              ></template
            >
          </el-table-column>
          <el-table-column prop="contName" label="联系人" align="center">
            <template slot-scope="scope">
              <span
                :class="
                  scope.row.jointCompNameNum && scope.row.jointCompNameNum > 1
                    ? 'redcolumn'
                    : ''
                "
              >
                {{ scope.row.contName }}</span
              ></template
            >
          </el-table-column>
          <el-table-column
            prop="contMobile"
            label="联系方式"
            align="center"
            min-width="110"
          >
            <template slot-scope="scope">
              <span
                :class="
                  scope.row.jointCompNameNum && scope.row.jointCompNameNum > 1
                    ? 'redcolumn'
                    : ''
                "
              >
                {{ scope.row.contMobile }}</span
              ></template
            >
          </el-table-column>
          <el-table-column
            v-if="ruleForm.dismantleWhether == 1 && ruleForm.jointWhether == 1"
            prop="jointCompName"
            label="联合公司名称"
            align="center"
            min-width="110"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span
                :class="
                  scope.row.jointCompNameNum && scope.row.jointCompNameNum > 1
                    ? 'redcolumn'
                    : ''
                "
              >
                {{ scope.row.jointCompName }}</span
              ></template
            >
          </el-table-column>
          <el-table-column
            prop="auditWhetherView"
            label="审核状态"
            align="center"
          >
            <template slot-scope="scope">
              <span
                :class="
                  scope.row.jointCompNameNum && scope.row.jointCompNameNum > 1
                    ? 'redcolumn'
                    : ''
                "
              >
                {{
                  scope.row.serveAuditWhether == 0
                    ? '待审核'
                    : scope.row.serveAuditWhether == 1
                    ? '审核通过'
                    : scope.row.serveAuditWhether == 2
                    ? '审核不通过'
                    : ''
                }}</span
              ></template
            >
          </el-table-column>
          <el-table-column prop="auditWhetherView" label="进度" align="center">
            <template slot-scope="scope">
              <span
                :class="
                  scope.row.jointCompNameNum && scope.row.jointCompNameNum > 1
                    ? 'redcolumn'
                    : ''
                "
              >
                {{
                  scope.row.scheduleCode == 1
                    ? '待审核'
                    : scope.row.scheduleCode == 2
                    ? '待提交'
                    : scope.row.scheduleCode == 3
                    ? '待复审'
                    : scope.row.scheduleCode == 4
                    ? '复审不通过'
                    : scope.row.scheduleCode == 5
                    ? '报名成功'
                    : scope.row.scheduleCode == 6
                    ? '报名失败'
                    : ''
                }}</span
              ></template
            >
          </el-table-column>
          <el-table-column prop="address" label="操作" align="center">
            <template slot-scope="scope">
              <el-button
                @click="handleClick(scope.row)"
                type="text"
                size="small"
                v-if="
                  scope.row.scheduleCode == 1 || scope.row.scheduleCode == 4
                "
                >审核</el-button
              >
              <el-button
                @click="handleClick(scope.row)"
                type="text"
                size="small"
                v-else
                >查看</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-dialog
        title="审批意见"
        :visible.sync="dialogTableVisible"
        :modal-append-to-body="false"
      >
        <el-form :model="form">
          <el-form-item label="审批意见：">
            <template slot="label">
              共有 {{ number }} 个竞买人报名同时审批通过
            </template>
            <el-input
              v-model="form.auditRemark"
              type="textarea"
              :rows="4"
              maxlength="200"
              show-word-limit
            ></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogTableVisible = false">取 消</el-button>
          <el-button type="primary" @click="submit">确 定</el-button>
        </div>
      </el-dialog>

      <bulk-import-dialog
        :visible.sync="biddingCondVisible"
        @onConfirm="onImportConfirm"
        @onChange="onChange"
        :mistakelist="mistakelist"
      ></bulk-import-dialog>
      <el-button type="primary" @click="down" class="down">返回</el-button>
    </div>
  </div>
</template>
<script>
export default {
  components: {},
  data() {
    return {
      auditVisible: false,
      number: '0',
      form: {
        auditRemark: ''
      },
      ruleForm: {
        title: '',
        code: '',
        bidStartTime: '',
        instructions: ''
      },
      tableData: [],
      multipleSelection: [],
      dialogTableVisible: false,
      choose: '',
      biddingCondVisible: false,
      mistakelist: []
    }
  },
  computed: {
    typeId() {
      return this.$route.query.id
    }
  },
  created() {
    this.noticeGet()
    this.enroollGet()
  },
  methods: {
    async noticeGet() {
      let data = await this.$api.materialdisposal.noticeGet({
        id: this.typeId
      })
      this.ruleForm = data
    },
    async enroollGet() {
      let data = await this.$api.serviceProvider.getServelist({
        noticeId: this.typeId
      })
      this.tableData = data.data
      //   this.ruleForm = data
    },
    onSubmit() {
      if (this.multipleSelection.length === 0) {
        this.$message.warning('至少选择一个竞买人')
      } else {
        let flag = this.multipleSelection.every(item => item.scheduleCode == 2)
        if (flag) {
          this.submitEnroollAudit()
        } else {
          this.$message.warning('只有待提交状态可以提交!')
        }
      }
    },
    async submitEnroollAudit() {
      let list = this.multipleSelection.map(item => {
        return item.id
      })
      let params = {
        ids: list.toString()
      }
      let data = await this.$api.serviceProvider.submitEnroollAudit(params)
      if (data) {
        this.$refs.multipleTable.clearSelection()
        this.enroollGet()
        this.$message.success('提交成功')
      }
    },
    operation() {
      if (this.multipleSelection.length === 0) {
        this.$message.warning('至少选择一个竞买人')
      } else {
        let flag = this.multipleSelection.every(
          item => item.scheduleCode == 1 || item.scheduleCode == 4
        )
        console.log(flag)
        if (!flag) {
          this.$message.warning('所选数据存在已审核数据，请核查!')
        } else {
          let list = this.multipleSelection.map(item => {
            return item.id
          })
          console.log(list)
          let query = {
            noticeID: this.typeId,
            ids: list.toString()
          }
          this.$router.push({
            name: 'CommissionAnnouncementBatchConfim',
            query
          })
        }
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
      this.number = this.multipleSelection.length
    },
    selectable(row) {
      if (
        row.scheduleCode == 3 ||
        row.scheduleCode == 5 ||
        row.scheduleCode == 6
      ) {
        return false
      } else {
        return true
      }
    },
    async submit() {
      if (this.multipleSelection.length === 1) {
        this.choose = this.multipleSelection[0].id.toString()
      } else {
        this.multipleSelection.map((item, index) => {
          if (index === 0) {
            this.choose = item.id
          } else {
            this.choose = this.choose + ',' + item.id
          }
        })
      }
      let query = {
        auditRemark: this.form.auditRemark,
        ids: this.choose
      }
      let data = await this.$api.materialdisposal.auditBatch(query)
      this.dialogTableVisible = false
      if (data) {
        this.$message.success('审批成功')
        this.enroollGet()
      }
    },
    oncompName(o) {
      let query = {
        compCode: o.compCode,
        source: 'service'
      }
      this.$openNewPage('BuyerInformation', query)
    },
    handleClick(o) {
      let query = {
        id: o.id,
        noticeID: this.typeId,
        typequery: o.scheduleCode == 1 || o.scheduleCode == 4 ? '' : '1'
      }
      this.$router.push({ name: 'QualificationAuditSingle', query })
    },
    down() {
      this.$router.push({ name: 'ServiceContractsManagement' })
    },
    onLead() {
      this.biddingCondVisible = true
    },
    async onChange(file) {
      console.log(file)

      let form = new FormData()
      form.append('file', file.raw)
      // form.append('noticeId', this.typeId)
      console.log(form)
      let res = await this.$api.serviceProvider.importAuditEntrustEnroollservice(
        this.typeId,
        form
      )
      console.log(res)
      if (res) {
        if (res && res.length > 0) {
          this.mistakelist = res
        } else {
          this.$message.success('导入成功')
          this.enroollGet()
        }
      }
    },
    onImportConfirm() {
      this.biddingCondVisible = false
      this.mistakelist = []
    },
    async exportNoAudit() {
      let res = await this.$api.serviceProvider.exportNoAuditdownloadservice(
        this.typeId
      )
      let blob = new Blob([res], { type: 'application/vnd.ms-excel' })
      let fileName = `${this.ruleForm.code}资格审核`
      const link = document.createElement('a')
      link.href = URL.createObjectURL(blob)
      link.download = fileName
      link.click()
      link.remove()
      URL.revokeObjectURL(link.href)
    }
  }
}
</script>
<style lang="less" scoped>
.titleone {
  margin: 5px;
  margin-top: 15px;
  width: 10px;
  height: 22px;
  background: #2587ff;
  float: left;
}
.title {
  padding: 10px;
  height: 30px;
  margin-top: 10px;
  margin-bottom: 20px;
  background: #ecf5ff;
  font-size: 15px;
  line-height: 15px;
}
.titlesplic {
  float: right;
  color: royalblue;
  cursor: pointer;
}
.form {
  padding-right: 50px;
  padding-left: 100px;
}
.instructions {
  min-height: 120px;
  line-height: 20px;
  margin-left: 60px;
}
.titlepen {
  padding-left: 50px;
  position: relative;
}
.titlepenleft {
  position: absolute;
  // margin-left: 10px;
  top: 20px;
  left: 50x;
}
.titlepenright {
  float: right;
}
.down {
  margin: 20px 550px;
}
.redcolumn {
  color: red;
}
</style>
